<template>
  <div class="sliders">
    <!-- Beautiful-interface-Section start -->
    <section class="row_am interface_section">
      <!-- container start -->
      <div class="container-fluid">
        <div
          class="section_title"
          data-aos="fade-up"
          data-aos-duration="1500"
          data-aos-delay="300"
        >
          <h2>Beautiful Interface. <span>Effortless Booking.</span></h2>
          <p>
            Designed for beauty lovers on the go. Navigate bookings, notifications, profiles,<br />
            and payments with intuitive screens that make styling your hair as easy as tapping your phone.
          </p>
        </div>

        <!-- screen slider start -->
        <div class="screen_slider">
          <swiper
            :modules="modules"
            :slides-per-view="5"
            :slides-per-group="1"
            :space-between="20"
            :loop="true"
            :autoplay="{
              delay: 2000,
              disableOnInteraction: false,
              pauseOnMouseEnter: true
            }"
            :speed="800"
            :grab-cursor="true"
            :breakpoints="{
              320: { slidesPerView: 1, spaceBetween: 10 },
              480: { slidesPerView: 2, spaceBetween: 12 },
              768: { slidesPerView: 3, spaceBetween: 15 },
              1024: { slidesPerView: 4, spaceBetween: 18 },
              1200: { slidesPerView: 5, spaceBetween: 20 }
            }"
            class="mySwiper"
          >
            <swiper-slide v-for="(img, index) in slides" :key="index">
              <div class="screen_frame_img">
                <img :src="`images/${img}`" :alt="`App screen ${index + 1}`" />
              </div>
            </swiper-slide>
          </swiper>
        </div>
        <!-- screen slider end -->
      </div>
      <!-- container end -->
    </section>
    <!-- Beautiful-interface-Section end -->
  </div>
</template>

<script setup>
// Import Swiper Vue Components
import { Swiper, SwiperSlide } from 'swiper/vue';

// Import required modules
import { Autoplay } from 'swiper/modules';

// Import Swiper styles
import 'swiper/css';

// Your 6 images (minimum 6 recommended for smooth loop with 5-view)
const slides = [
  'screen-01.png',
  'screen-02.png',
  'screen-03.png',
  'screen-04.png',
  'screen-05.png',
  'screen-03.png' // duplicate one to ensure smooth loop
];

// Modules to use
const modules = [Autoplay];
</script>

<style scoped>
.screen_slider {
  padding: 30px 0;
}

.mySwiper {
  overflow: hidden;
}

:deep(.swiper-slide) {
  transition: transform 0.3s ease;
}

:deep(.swiper-slide img) {
  width: 100%;
  height: auto;
  border-radius: 12px;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
}

:deep(.swiper-slide:hover img) {
  transform: translateY(-4px);
  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.12);
}
</style>